import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../components/ProgressBar';
import logoHeader from '../assets/logo_header.png';
import whatsappIcon from '../assets/icon_wa.png';

const Failed = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FCFAF7]">
      {/* Progress Bar */}
      <ProgressBar currentStep={3} />
      
      <div className="flex flex-col items-center justify-center p-4 pt-16">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 text-center">
        <img 
          src={logoHeader} 
          alt="Shaun Dju Academy" 
          className="h-12 mx-auto mb-8"
        />
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-[#203D32] mb-4">Payment Failed</h1>
        <p className="text-gray-600 mb-8">
          We couldn't process your payment. Please try again or contact our support team at +6287841393601.
        </p>
        <p className="text-gray-600 mb-8">
          You can also click the WA Icon below to automatically message the team.
        </p>
        
        
        {/* WhatsApp Contact Button */}
        <div className="mb-6">
          <a
            href="https://api.whatsapp.com/send/?phone=6287841393601"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-16 h-16 bg-[#203D32] hover:bg-green-600 rounded-full transition-colors duration-300 shadow-lg hover:shadow-xl"
          >
            <img 
              src={whatsappIcon} 
              alt="Contact us on WhatsApp" 
              className="w-8 h-8"
            />
          </a>
          <p className="text-sm text-gray-500 mt-2">Need Help? Contact Support</p>
        </div>
        
        <button
          onClick={() => navigate('/checkout')}
          className="bg-[#203D32] text-white px-8 py-3 rounded-full font-semibold hover:opacity-90 transition"
        >
          Try Again
        </button>
      </div>
      </div>
    </div>
  );
};

export default Failed; 